// initial state
import axios from "axios";

const state = () => ({
    offices: [],
    roles: []
})

// getters
const getters = {}

// actions
const actions = {
    async getData ({ commit }) {
        axios.get(route('admin.users.getData')).then(result => {
            commit('setOffices', result.data.offices);
            commit('setRoles', result.data.roles);
        });
    }
}

// mutations
const mutations = {
    setOffices (state, offices) {
        state.offices = offices
    },
    setRoles (state, roles) {
        state.roles = roles
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
